<div class="chess-board">
  @for (lever of levers(); track lever.id) {
    <div
      class="chess-board__item"
      [class.chess-board__item--active]="lever.id === selectedLever"
      [class.chess-board__item--clickable]="!showMode"
      (click)="selectedLeverChange.emit(lever)"
    >
      <div
        class="chess-board__info"
        (click)="openLeverDialog($event, lever)"
      >
        <mat-icon class="chess-board__info-icon">info</mat-icon>
      </div>
      {{ lever.id }} - {{ lever.name }}
    </div>
  }
</div>
